import React from "react";
import styles from "./index.module.scss";

const NoTabsMessage: React.FC = () => {
  return (
    <div className={styles.noTabs}>
      <div className={styles.noTabsItem}></div>
      <div className={styles.noTabsItem}></div>
    </div>
  );
};

export default NoTabsMessage;
